var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 14 14",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-287 -23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m294.707311 29.9998437 5.146258-5.1462587c.194991-.1954909.194991-.511476 0-.7069669-.195491-.1954908-.511976-.1954908-.706967 0l-5.146258 5.1462588-5.146759-5.1462588c-.195491-.1954908-.511476-.1954908-.706967 0-.195491.1949909-.195491.511476 0 .7069669l5.146759 5.1462587-5.146759 5.1467587c-.194991.1949909-.195491.511976 0 .7069669.195491.1954908.511976.1949909.706967 0l5.146759-5.1467587 5.146258 5.1462587c.194991.1949909.511476.1954909.706967 0 .195491-.1954908.194991-.511976 0-.7069668z",
    fill: "currentColor",
    stroke: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f82166617d0f73317c8c2ee70f72a11c.svg";
export { ForwardRef as ReactComponent };